module.exports = __webpack_public_path__ + "img/info_host_unitlang.663bfdf9.png";